$(document).ready(function(){
    Genel();
    //
    $('.language-container>.selected').on('click', function (event) {

        $('.language-container>.language-wrapper').toggleClass('toggled');
    
        if ($(this).hasClass('toggled')) {
            
        } else{
            
        }
    });
});

$(window).resize(function(){
	Genel();
});

function Genel(){
	Genislik = $(window).width();
	Yukseklik = $(window).height();
}

function eMenu(){
	$('.mobilmenu').toggleClass('open');
	$('.mainmenu').slideToggle();
}

function sendFormContact() {
    var elm = $('#contactform');
    var url = elm.attr("data-url");
    if (elm.length > 0) {
        $.ajax({
            type:'POST',
            data: new FormData(elm[0]),
            url: url,
            dataType:'JSON',
            async:true,
            processData: false,
            contentType: false,
            success:function(res){
                var msg = postFormMessage(res, elm);
                elm.find('#submitFormStatus').html(msg);
            }
        });
        return false;
    }
}

function postFormMessage(e, elm)
{
    var html = '';
    if(e.errors) {
        html = '<div class="res-danger"><h4 class="block">!</h4><ul>';
        $.each(e.errors, function (key, val) {
            html += '<li>' + val + '</li>';
        });
        html += '</ul></div>';
    }
    else if (e.success) {
        html = '<div class="res-success">' + e.msg + '</div>';
        formReset(elm);
    }
    else{
        html = '<div class="res-danger">System error:<br>' + e.msg + '</div>';
    }
    return html;
}

function formReset(elm) {
    $(elm).each(function () {
        this.reset();
    });
}

function eTab(tabid){
	$('.taba').removeClass('active');
	$('#taba-'+tabid).addClass('active');
	$('.tabcontent').hide();
	$('#tabcontent-'+tabid).show();
}
